var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"filled":"","rounded":"","disabled":_vm.isDisabled,"value":_vm.value,"type":_vm.question.input_type},on:{"change":function (value) { return _vm.$emit('update', value); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }